import React from 'react';
import { X, Rocket, Users, Calendar } from 'lucide-react';

const WelcomeDialog = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-2xl overflow-hidden animate-scale-up">
        <div className="p-6 bg-gradient-to-br from-purple-600 to-pink-500">
          <div className="flex justify-between items-start">
            <h2 className="text-2xl font-bold text-white">Welcome to LeadrPro! 👋</h2>
            <button onClick={onClose} className="text-white/80 hover:text-white">
              <X className="w-5 h-5" />
            </button>
          </div>
          <p className="mt-2 text-white/90">Your all-in-one platform for B2B lead generation and management</p>
        </div>
        
        <div className="p-6 space-y-6">
          <div className="grid gap-6 md:grid-cols-3">
            <div className="bg-purple-50 rounded-xl p-4 transform transition-transform hover:scale-105">
              <div className="bg-purple-100 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
                <Rocket className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="font-semibold text-purple-900 mb-2">Product Launches</h3>
              <p className="text-sm text-purple-700">Get featured in our weekly launches to drive targeted traffic and leads</p>
            </div>

            <div className="bg-pink-50 rounded-xl p-4 transform transition-transform hover:scale-105">
              <div className="bg-pink-100 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-pink-600" />
              </div>
              <h3 className="font-semibold text-pink-900 mb-2">Lead Management</h3>
              <p className="text-sm text-pink-700">Track and manage all your leads in one central dashboard</p>
            </div>

            <div className="bg-blue-50 rounded-xl p-4 transform transition-transform hover:scale-105">
              <div className="bg-blue-100 rounded-lg w-12 h-12 flex items-center justify-center mb-4">
                <Calendar className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-semibold text-blue-900 mb-2">Book Demos</h3>
              <p className="text-sm text-blue-700">Connect with qualified prospects and schedule demos effortlessly</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-lg font-medium hover:from-purple-700 hover:to-pink-600 transform hover:scale-105 transition-all duration-200"
          >
            Let's Get Started →
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeDialog;
